// extracted by mini-css-extract-plugin
module.exports = {"ActiveAlarms":"AlarmList_ActiveAlarms__1ThX3","spindindust":"AlarmList_spindindust__jDTJa"};